export var Theme;
(function (Theme) {
  Theme["LIGHT"] = "light";
  Theme["DARK"] = "dark";
})(Theme || (Theme = {}));